import { useFormikContext } from 'formik';
import React from 'react';

import {
  LocationSearch,
  Location,
} from '@components/LocationSearch/LocationSearch';
import { FormValues } from '@components/Projects/ProjectFormStack';

export const ProjectLocationSearch: React.FC = () => {
  const { setFieldValue, setTouched, touched } = useFormikContext<FormValues>();

  return (
    <LocationSearch
      // TA-10950 #19: standard search-box spec, scoped to Create Project
      // only (Jo's sign-off, recorded on TA-10950) - every other screen
      // sharing LocationSearch.web keeps the pre-existing layout.
      variant='standard'
      onSelect={(location: Location) => {
        setFieldValue('location', location);
        setTouched({ ...touched, location: true });
      }}
    />
  );
};
